module.exports = __webpack_public_path__ + "media/images/map-icons/icon2_unselected-59cbae05120ec74295feffebd59fe93a.png";